<template>
  <div id="partners" class="sec" >
    <v-container>
      <v-row justify="center">
        <div
          class="head"
          :class="MIXIN_SETUP_UI.header"
          data-aos="fade-up"
        >Our Partners</div>
        <!-- <div class="display-2 head" data-aos="fade-up">Our Partners</div> -->
      </v-row>

      <v-row justify="center" data-aos="fade-up" :class="MIXIN_SETUP_UI.defaultSidePadding">
        <v-col
          cols="12" sm="6" md="4" lg="4" xl="4"
          v-for="(partner, key) in partners"
          :key="key"
          
        >
          <partner-card
            :url="partner.url"
            :backgroundImage="partner.backgroundImage"
            :name="partner.name"
          ></partner-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PartnerCard from "@/components/home/PartnerCard.vue";

import Repository from "@/api/repositories";
const PartnersApi = Repository.get("partners");

  export default {
    name: "PartnersSection",
    components: {
      PartnerCard
    },
    data: () => ({
      partners: [],
      overlay: false
    }),
    mounted() {
      this.getMediaArticles();
    },
    methods: {
      async getMediaArticles() {
        try {
          const { data } = await PartnersApi.get();
          
          if (data) {
            data.data.sort(function(a, b) {
              return a.precedence - b.precedence;
            });

            let partners = data.data.map(partner => {
              return {
                name: partner.name,
                url: partner.url,
                backgroundImage: partner.background_image.main,
              }
            });

            this.partners = partners;
          }

          console.log('[partners]', data, this.partners);
        }
        catch(error) {
          console.log(error);
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

#partners {
  background: $gray;
}
</style>